export default {
  language: 'fa',
  messages: {
    confirm_remove: 'فرآیند حذف بدون بازگشت است! می خواهید ادامه دهید؟'
  },
  buttons: {
    disagree: 'موافق نیستم',
    agree: 'موافقم',
    more: 'بیشتر',
    reload: 'بازنشانی'
  },
  models: {
    name: 'عنوان',
    isadmin: 'مدیر سیستم',
    enable: 'فعال',
    draft: 'پیش نویس',
    description: 'توضیحات',
    order: 'ترتیب',
    image: 'تصویر',
    question: 'سوال',
    answers: 'پاسخ ها',
    phone: 'شماره تماس',
    password: 'کلمه عبور',
    isCorrect: 'جواب صحیح'
  },
  statistics: {
    seven_days_report: 'گزارش مشارکت هفت روز اخیر',
    total_answers: 'پاسخ ها',
    correct_answers: 'پاسخ درست',
    incorrect_answers: 'پاسخ نا درست',
    members: 'کاربران',
  },
  general: {
    wellcome_member: 'به سامانه مدیریت آوید فلش کارد خوش آمدید!',
    reviewPreviousChapter: 'مرور فصل های قبل',
    back: ' بازگشت',
    add: 'افزودن'
  },
  user: {
    account: 'حساب کاربری'
  },
  auth: {
    insert_mobile_number: 'شماره موبایل خود را وارد کنید'
  },
  message: {
    otpWrong: 'کد وارد شده صحیح نمی باشد! لطفا دوباره تلاش کنید.',
    userNotFound: 'کاربری با این شماره در سیستم وجود ندارد!',
    add_mobile_number: 'شماره موبایل خود را وارد کنید',
    error_mobile_number: '.شماره موبایل به درستی وارد نشده است'
  },
  pages: {
    question_edit: {
      title: 'ویرایش سوال'
    },
    course_add: {
      title: 'افزودن دوره جدید'
    },
    chapter_add: {
      title: 'افزودن فصل جدید به دوره '
    },
    index: {
      title: 'داشبورد'
    },
    dashboard: {
      title: 'داشبورد'
    },
    members: {
      title: 'کاربران'
    },
    intro: {
      title: ''
    },
    profile: {
      title: 'حساب کاربری'
    },
    logout: {
      title: 'خروج'
    },
    courses: {
      title: 'دوره های آموزشی'
    },
    review: {
      title: 'بازبینی'
    },
    support: {
      title: 'پشتیبانی'
    },
    chapters: {
      title: 'سوالات  فصل'
    },
    chapters: {
      title: 'فصل های دوره'
    },
    questions: {
      title: 'سوالات'
    },
    answers: {
      title: 'پاسخ ها',
    },
    login: {
      title: 'ورود'
    },
    settings: {
      title: 'تنظیمات'
    }
  },
  selected_chapter: 'فصل ۲ - اندونتیکس ۱ عملی',
  timer_text: 'مدت اعتبار کد',
  settings: 'تنظیمات',
  support: 'پشتیبانی',
  countinue: 'ادامه',
  skip: 'رد کن',
  view_answer: 'مشاهده پاسخ',
  close_answer: 'بستن پاسخ',
  log_in: 'ورود',
  log_out: 'خروج',
  sing_up: 'ثبت نام',
  confirm_activation: 'تایید کد فعال سازی',
  resend_activation_code: 'ارسال دوباره کد فعال سازی',
  choose_answer: 'گزینه صحیح را انتخاب کنید:',
  correct_answer: 'گزینه صحیح:',
  description_answer: 'توضیحات',
  finish: 'پایان',
  correct_answer_count: 'سوالات پاسخ داده شده',
  wrong_answer_count: 'سوالات پاسخ داده نشده',
  chapters_review: 'مرور فصل',
  return_to_chapter: 'بازگشت به دوره',
  season_chapters: 'فصل های هر دوره',
  courses: 'دوره های آموزش دندانپزشکی',
  courses_list: 'دوره های آموزشی',
  // Remove all below
  need_data: 'این صفحه نیازمند اطلاعات و طراحی میباشد'
}
